module.exports = __webpack_public_path__ + "assets/img/12.5ab8ce13.png";